import { useEffect } from 'react';
import { supabase } from '@/lib/supabaseClient';
import { climateScenarioService } from '@/services/climateScenarioService';

/**
 * İklim senaryolarını otomatik günceller
 * Uygulama başlangıcında bir kez çalışır
 */
export function useClimateScenarios(enabled: boolean = true) {
  useEffect(() => {
    if (!enabled) return;

    // Her sayfa yüklemede kontrol et
    checkAndUpdateScenarios();
  }, [enabled]);

  async function checkAndUpdateScenarios() {
    try {
      // console.log('🔄 İklim senaryoları kontrol ediliyor...');
      
      // Auth kontrolü
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        return; // Sessiz atla
      }
      
      // Son güncelleme zamanını kontrol et
      const { data: lastUpdate } = await supabase
        .from('senaryo_sablonlari')
        .select('updated_at')
        .order('updated_at', { ascending: false })
        .limit(1)
        .single();

      const daysSinceUpdate = lastUpdate 
        ? Math.floor((Date.now() - new Date(lastUpdate.updated_at).getTime()) / (1000 * 60 * 60 * 24))
        : 999;

      // console.log(`📅 Son güncelleme: ${daysSinceUpdate} gün önce`);

      // 7 günden eski ise güncelle
      if (daysSinceUpdate > 7) {
        // console.log('⚠️ Veriler eski, güncelleniyor...');
        const scenarios = await climateScenarioService.fetchIPCCScenarios();
        // console.log(`📦 ${scenarios.length} senaryo alındı`);
        
        for (const scenario of scenarios) {
          const { error } = await supabase.from('senaryo_sablonlari').upsert({
            senaryo_kodu: scenario.kod,
            sablon_adi: scenario.ad,
            kategori: scenario.kategori,
            aciklama: scenario.aciklama,
            isinma_2030: scenario.isinma_2030,
            isinma_2050: scenario.isinma_2050,
            isinma_2100: scenario.isinma_2100,
            karbon_fiyati_2030: scenario.karbon_fiyati_2030,
            karbon_fiyati_2050: scenario.karbon_fiyati_2050,
            emisyon_azaltim_hedefi: scenario.emisyon_azaltim_hedefi,
            yenilenebilir_enerji_payi: scenario.yenilenebilir_enerji_payi,
            senaryo_tipi: scenario.kod.startsWith('SSP') ? 'IPCC' : 'IEA',
            kaynak: scenario.kod.startsWith('SSP') ? 'IPCC AR6' : 'IEA WEO 2023',
            aktif: true
          }, { onConflict: 'senaryo_kodu' });
          
          if (error) {
            console.error(`❌ ${scenario.kod} güncellenemedi:`, error);
          } else {
            // console.log(`✅ ${scenario.kod} güncellendi`);
          }
        }
        // console.log('✅ Tüm senaryolar güncellendi');
      } else {
        // console.log('✅ Veriler güncel, güncelleme gerekmiyor');
      }
    } catch (error) {
      console.error('❌ Senaryo güncelleme hatası:', error);
    }
  }
}
